import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ElementRef,
} from '@angular/core';
import { NgIf, NgClass } from '@angular/common';
import HeaderComponent from '../header/header.component';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [
        NgIf,
        NgClass,
        HeaderComponent,
    ],
})
export class ModalComponent {
  constructor(private elementRef: ElementRef) {}

  @Input() public extraClass: string | null = null;

  @Input() public show = false;

  @Input() public showBuddy = false;

  @Input() public cycModal = false;

  @Input() public uniListModal = false;

  @Output() private readonly showChange = new EventEmitter<boolean>();

  public closeModal(): void {
    this.show = false;
    this.showChange.emit(this.show);
  }

  public onKeydown(key: string): void {
    if (key === 'escape') {
      this.closeModal();
    }
  }

  /**
   * Previous onClickOutside function wasn't working correctly
   * (would run the closeModal function when performing an action like a button press but not when clicking on the modal )
   * so have replaced it to it checks for the modal-container class which is the area around the modal
   * @param event
   * @returns void
   */
  @HostListener('document:mousedown', ['$event'])
  public clickOutside(event: any): void {
    if (event.target.className === 'modal-container') {
      this.closeModal();
    }
  }
}
